export enum EmploymentType {
  Employee = 'Employee',
  Contractor = 'Contractor',
}
